import React from "react";
import { Title, Wrapper, Description } from "./Style";

const FAQComponents = () => {
  return (
    <Wrapper>
      <Title>FAQ</Title>
      <Description>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
        vulputate vestibulum Phasellus rhoncus, dolor eget viverra pretium,
        dolor tellus aliquet nunc vitae ultricies erat elit eu lacus. Vestibulum
        non justo consectetur, cursus ante, tincidunt sapien. Nulla quis diam
        sit amet turpis interdum accumsan quis nec enim. Vivamus faucibus ex sed
        nibh egestas elementum. Mauris et bibendum dui. Aenean consequat
        pulvinar luctus.
      </Description>
    </Wrapper>
  );
};

export default FAQComponents;
